/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable react/jsx-tag-spacing */
import React from 'react';
import ReactDOM from 'react-dom/client';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import './React/Style/index.css';

import { Provider } from 'react-redux';
import { App } from './App';
import { Config } from './Resources/Config';

import { ExeConfig } from './Resources/ExeConfig';
import { WebConfig } from './Resources/WebConfig';
import appStore from './Redux/Store/store';

import { softwareReleaseBuildId } from './globals/version';

// In case we must debig what babylon is trying to download uncomment next line
// import './common/libraries/modelViewer/babylon-io-logging';

// CAUTION: The following import as a set of side effects funtion calls, is not just an import
import {
  clearAllCaches, cssVarTrue, initAssetCaching, stopAssetCaching,
} from './common/libraries/modelViewer/babylon-cache-bootstrap';

function isElectron() : boolean {

  type WindowProcess =
  {
    type : string;
  };

  // Renderer process
  if (
    typeof window !== 'undefined'
    && typeof window.process === 'object'
    && (window.process as unknown as WindowProcess).type === 'renderer'
  ) {
    return true;
  }

  // Main process
  if (
    typeof process !== 'undefined'
    && typeof process.versions === 'object'
    && !!process.versions.electron
  ) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (
    typeof navigator === 'object'
    && typeof navigator.userAgent === 'string'
    && navigator.userAgent.indexOf('Electron') >= 0
  ) {
    return true;
  }

  return false;
}

function getConfig() : Config {
  if (isElectron()) {
    return ExeConfig();
  }
  return WebConfig();
}

function clearCacheHanler() : void {
  clearAllCaches();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

if (isElectron() === false) {
  // ------------------------------------------------
  // Proprietary cache initialization
  // ------------------------------------------------
  // Derive SW URL relative to current page
  const version = softwareReleaseBuildId ?? Date.now();

  // This resolves to /pos/sw.js if the app runs from /pos/
  const swUrl = new URL('sw.js', location.href);
  // Default scope = directory of the current page, e.g. /pos/
  const swScope = new URL('.', location.href).pathname;
  if (cssVarTrue('--disable-mindsales-cache')) {
    console.log('[mind-sales-cached: Stopping cache service worker');
    stopAssetCaching({
      swUrl: swUrl.toString(), scope: swScope, reload: true, clearCaches: false,
    });
  } else {
    console.log('[mind-sales-cached: Starting cache service worker');
    stopAssetCaching({
      swUrl: swUrl.toString(), scope: swScope, reload: false, clearCaches: false,
    });
    swUrl.searchParams.set('v', String(version));
    // Launch cache + service worker bootstrap
    if (window.isSecureContext && 'serviceWorker' in navigator) {
      initAssetCaching({ swUrl: swUrl.toString(), scope: swScope, reloadOnActivate: true });
    } else {
      console.warn('[babylon-cache] Service Worker disabled: insecure or electron context.');
    }
  }
} else {
  console.log('Skipping cache service worker!');
}

root.render(
  <React.StrictMode>
    <Provider store={appStore}>
      <App configurations={getConfig()} clearCacheHandler={clearCacheHanler} />
    </Provider>
  </React.StrictMode>,
);
